export default {
	"035f2f9f1063b2101c8f177bac542fce": "Modify the address",
	"e10e5c0ac5284f1f71fa5491770e60be": "Consult customer service"
}
